














































import { defineComponent, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import { AdgroupFormData, FullNormalFormData, CreativeConfig, CampaignFormData, ACTION_TYPE } from '@tt4b/ttam-enums';
import ProductDetails from './index';
import { useProductDetailValidate, useCreativeActionTypeIs } from '@tt4b/ttam-hooks';

const name = 'ttam-product-details-shop-compose';
export default defineComponent({
  name,
  components: {
    TtamProductDetailsSource: ProductDetails.TtamProductDetailsSource,
    TtamProductDetailsDesc: ProductDetails.TtamProductDetailsDesc,
    TtamProductDetailsProductList: ProductDetails.TtamProductDetailsProductsList,
    TtamProductDetailsProductsListActions: ProductDetails.TtamProductDetailsProductsListActions,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit, refs }) {
    const { adgroupData, creativeData, campaignData, createMode } = toRefs<{
      adgroupData: AdgroupFormData;
      creativeData: FullNormalFormData;
      campaignData: CampaignFormData;
      createMode: string;
    }>(props);
    const shopInfo = ProductDetails.useShopInfo({ adgroupData });
    const spuIdList = computed(() => creativeData.value.spuList);
    const { isCopy } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });

    const { productListDataSource, onProductListChange } = ProductDetails.useProductListForShop({
      creativeData,
      emit,
    });

    const validate = () => {
      refs.spuListFormItem?.validate('change');
    };

    const { openDrawer, clear } = ProductDetails.useListActions(emit);

    const { spuListValidator } = useProductDetailValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    onMounted(() => {
      if (isCopy.value) {
        // copy的时候进页面就需要校验一下
        refs.spuListFormItem?.validate('change');
      }
    });

    watch(
      () => creativeData.value.spuList?.length,
      () => {
        validate();
      },
    );

    return {
      name,
      shopInfo,
      productListDataSource,
      onProductListChange,
      openDrawer,
      clear,
      spuListValidator,
    };
  },
});
